<template>
    <transition name="slide-fade">
        <tr v-if="showSub" class="bg-white">
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            {{$t(`${index}`)}} <span v-if="name == 'noEssentialAminoAcids'">**</span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
            <div v-if="dailyCalc">{{ dailyCalc }} {{ units[name][index] }}</div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
            {{ value }} {{ units[name][index] }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
            <div v-if="dailyPercent">{{ dailyPercent.toFixed(2) }} % <span v-if="name == 'essentialAminoAcids'">***</span></div>
            </td>
        </tr>  
    </transition>
</template>

<script>
import dailyValues from '@/calorie-table/dailyValues.json'
import units from '@/calorie-table/units.json'

export default {
    name: 'SubTable',
    data () {
        return {
            daily: dailyValues,
            units: units
        }
    },
    props: {
        index: {
            Type: String
        },
        value: {
            Type: Number
        },
        arrayAll: {
            Type: Array
        },
        name: {
            Type: String
        },
        gender: {
            Type: String
        },
        weight: {
            Type: Number
        }
    },
    computed: {
        dailyCalc() {
            if (this.name == 'essentialAminoAcids') {
                return this.daily[this.gender][this.name][this.index] * this.weight
            } else {
            return this.daily[this.gender][this.name][this.index]
            }
        },
        dailyPercent() {
            return this.dailyCalc ? (this.value / this.dailyCalc) * 100 : null
        },
        allSubs () {
            console.log(Object.keys(this.uitem))
            return this.uitem
        },
        showSub () { 
            return this.arrayAll.includes(this.name)
        }
    }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .5s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(100px);
  opacity: 0;
}

</style>